(function () {
  'use strict';
  if (window.WallForgePortraitLibrary) return;
  const H = window.WallForgePortraitHistory;
  const root = () => document.querySelector('[data-portrait-page]');
  const copy = () => JSON.parse(document.querySelector('[data-portrait-copy]')?.textContent || '{}');
  const text = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll('{' + k + '}', String(v)), copy()[key] || key);
  const counted = (n, name) => text(name + (n === 1 ? '_one' : '_many'), { count: n });
  const element = (tag, className, content) => { const node = document.createElement(tag); if (className) node.className = className; if (content !== undefined) node.textContent = content; return node; };
  const identity = (group, item) => JSON.stringify([group.designId, item.version.id]);
  const signature = groups => JSON.stringify(groups.map(group => [group.designId, group.design.title, group.versions.map(item => [item.version.id, item.number, item.version.previewUrl])]));
  function renderGroups(container, groups, { picker = false, selected, onSelect } = {}) {
    container.replaceChildren();
    for (const group of groups) {
      const section = element('section', 'wf-portraits__group'); section.dataset.portraitDesign = group.designId; section.setAttribute('aria-label', group.design.title);
      const heading = element('div', 'wf-portraits__group-heading');
      heading.append(element(picker ? 'h3' : 'h2', '', group.design.title), element('span', '', counted(group.versions.length, 'versions')));
      const list = element('ul', 'wf-portraits__grid');
      for (const item of group.versions) {
        const key = identity(group, item), checked = selected === key;
        const card = element(picker ? 'button' : 'a', 'wf-portraits__card' + (checked ? ' is-selected' : ''));
        card.dataset.portraitKey = key; card.dataset.portraitId = item.version.id; card.dataset.designId = group.designId;
        card.setAttribute('aria-label', text(picker ? 'select' : 'open', { design: group.design.title, number: item.number }));
        if (picker) { card.type = 'button'; card.setAttribute('aria-pressed', String(checked)); card.onclick = () => onSelect(key); }
        else card.href = H.portraitUrl(group, item.version.id);
        const frame = element('span', 'wf-portraits__image'), image = element('img');
        const status = element('span', 'wf-portraits__image-status'), spinner = element('span', 'wf-portraits__spinner');
        spinner.setAttribute('aria-hidden', 'true');
        const message = element('span'); status.append(spinner, message);
        const imageState = state => {
          frame.dataset.imageState = state; frame.setAttribute('aria-busy', String(state === 'loading'));
          status.hidden = state === 'ready'; spinner.hidden = state !== 'loading';
          message.textContent = text(state === 'unavailable' ? 'preview_unavailable' : 'preview_loading');
        };
        imageState('loading');
        image.alt = ''; image.width = 220; image.height = 330; image.loading = 'lazy';
        image.addEventListener('load', () => imageState(image.naturalWidth ? 'ready' : 'unavailable'));
        let retried = false;
        // Conceal failed images while refreshing; bound retries and provide a quiet fallback.
        image.addEventListener('error', async () => {
          imageState('loading');
          if (retried) { imageState('unavailable'); return; }
          retried = true;
          try {
            await H.refresh(group, item, true);
            const current = await H.currentVersion(group, item);
            if (!image.isConnected) return;
            const next = H.safeImage(current?.previewUrl);
            // A temporary image failure may renew to the same still-valid URL.
            // Retry that request too; an unchanged URL is not missing artwork.
            if (next) image.src = next;
            else imageState('unavailable');
          } catch (_) { if (image.isConnected) imageState('unavailable'); }
        });
        const load = async () => {
          try {
            // Do not send known-expired URLs to the image endpoint first.
            if (H.needsRefresh(item.version)) await H.refresh(group, item);
            const current = await H.currentVersion(group, item);
            if (!image.isConnected) return;
            const src = H.safeImage(current?.previewUrl);
            if (src) image.src = src; else imageState('unavailable');
          } catch (_) { if (image.isConnected) imageState('unavailable'); }
        };
        frame.append(image, status);
        if (picker) { const check = element('span', 'wf-portraits__check', '✓'); check.setAttribute('aria-hidden', 'true'); check.hidden = !checked; frame.append(check); }
        const caption = element('span', 'wf-portraits__caption'); caption.append(element('span', '', text('version', { number: item.number })));
        const annotation = element('span', picker ? 'wf-portraits__selected' : 'wf-portraits__arrow', picker ? text('selected') : '→');
        if (picker) annotation.hidden = !checked; else annotation.setAttribute('aria-hidden', 'true');
        caption.append(annotation); card.append(frame, caption); const li = element('li'); li.append(card); list.append(li);
        load();
      }
      section.append(heading, list); container.append(section);
    }
  }
  async function openPicker(studio) {
    const dialog = studio.el('[data-versions-dialog]'), body = dialog.querySelector('[data-portrait-picker-groups]');
    const summary = dialog.querySelector('[data-picker-summary]'), confirm = dialog.querySelector('[data-use-portrait]');
    const loading = dialog.querySelector('[data-picker-loading]'), error = dialog.querySelector('[data-picker-error]');
    const opening = Symbol(); dialog.portraitOpening = opening;
    let selected = JSON.stringify([studio.state.designId, studio.state.selectedId]), groups = [];
    const active = () => dialog.open && dialog.portraitOpening === opening;
    const find = () => groups.flatMap(group => group.versions.map(item => ({ group, item }))).find(({ group, item }) => identity(group, item) === selected);
    function mark() {
      const chosen = find(); confirm.disabled = !chosen;
      summary.textContent = chosen ? chosen.group.design.title + ' · ' + text('version', { number: chosen.item.number }) : '';
      body.querySelectorAll('[data-portrait-key]').forEach(card => {
        const checked = card.dataset.portraitKey === selected;
        card.classList.toggle('is-selected', checked); card.setAttribute('aria-pressed', String(checked));
        card.querySelector('.wf-portraits__check').hidden = !checked; card.querySelector('.wf-portraits__selected').hidden = !checked;
      });
    }
    function render() {
      body.replaceChildren();
      dialog.querySelector('[data-picker-count]').textContent = text('across', { portraits: counted(H.count(groups), 'portraits') });
      const current = groups.filter(group => group.designId === studio.state.designId), others = groups.filter(group => group.designId !== studio.state.designId);
      for (const [label, list] of [['this_design', current], ['other_designs', others]]) {
        if (!list.length) continue;
        const section = element('section', 'wf-portraits__picker-section'), content = element('div');
        section.append(element('h2', '', text(label)), content); body.append(section);
        renderGroups(content, list, { picker: true, selected, onSelect: key => { selected = key; mark(); } });
      }
      dialog.querySelector('[data-picker-empty]').hidden = groups.length > 0; mark();
      dialog.querySelector('.wf-portraits__action').hidden = !groups.length;
    }
    body.replaceChildren(); summary.textContent = ''; error.hidden = true; loading.hidden = false; confirm.disabled = true;
    studio.open(dialog);
    confirm.onclick = async () => {
      const chosen = find(); if (!chosen || !active()) return;
      confirm.disabled = true;
      if (chosen.group.designId === studio.state.designId) {
        dialog.close(); await studio.selectVersion(chosen.item.version.id, true);
      } else location.assign(H.portraitUrl(chosen.group, chosen.item.version.id));
    };
    try {
      await studio.persist(); groups = await H.groups(studio.state.designId);
      if (!active()) return; render(); loading.hidden = true;
      await H.refreshGroups(groups);
      if (!active()) return;
      groups = await H.groups(studio.state.designId);
      const focusKey = document.activeElement?.dataset.portraitKey;
      render();
      if (focusKey) Array.from(body.querySelectorAll('[data-portrait-key]')).find(card => card.dataset.portraitKey === focusKey)?.focus({ preventScroll: true });
    } catch (_) { if (active()) error.hidden = false; }
    finally { if (active()) loading.hidden = true; }
  }
  async function mountPage() {
    const page = root(); if (!page || page.dataset.mounted) return;
    const url = new URL(location.href), view = url.searchParams.has('wf_saved') ? 'saved' : url.searchParams.get('wf_view');
    if (!['portraits', 'saved', 'save', 'save-success', 'saved-empty'].includes(view)) return;
    page.dataset.mounted = 'true'; url.searchParams.delete('wf_saved'); url.searchParams.set('wf_view', 'portraits'); history.replaceState(history.state, '', url.href);
    document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (main) { Array.from(main.children).forEach(child => { child.hidden = true; }); main.append(page); }
    else document.querySelectorAll('[data-wf-studio]').forEach(node => { node.hidden = true; });
    page.hidden = false; document.title = text('title') + ' – Wallforge';
    const loading = page.querySelector('[data-portraits-loading]'), error = page.querySelector('[data-portraits-error]');
    let previousSignature, reading = false;
    const render = groups => {
      const nextSignature = signature(groups);
      // Connectivity recovery can fix an image without changing its URL or record.
      if (nextSignature === previousSignature && !page.querySelector('[data-image-state="unavailable"]')) return;
      previousSignature = nextSignature;
      const focused = document.activeElement?.dataset.portraitKey;
      page.querySelector('[data-portraits-count]').textContent = H.count(groups) ? counted(H.count(groups), 'portraits') + ' · ' + counted(groups.length, 'designs') : '';
      renderGroups(page.querySelector('[data-portraits-groups]'), groups);
      page.querySelector('[data-portraits-empty]').hidden = groups.length > 0;
      if (focused) Array.from(page.querySelectorAll('[data-portrait-key]')).find(card => card.dataset.portraitKey === focused)?.focus({ preventScroll: true });
    };
    const sync = async () => {
      if (reading || document.hidden || !page.isConnected) return;
      reading = true;
      try {
        const groups = await H.groups(); render(groups); loading.hidden = true;
        await H.refreshGroups(groups); render(await H.groups()); error.hidden = true;
      } catch (_) { error.hidden = false; }
      finally { reading = false; loading.hidden = true; }
    };
    const timer = setInterval(() => { if (page.isConnected) sync(); else clearInterval(timer); }, 60000);
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('online', sync);
    window.addEventListener('pageshow', event => { if (event.persisted) sync(); });
    await sync();
  }
  window.WallForgePortraitLibrary = { openPicker, mountPage };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountPage); else mountPage();
})();
